import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { getUsername } from "../../../ducks/user";

export const InvalidWorkspaceMessage: FC = () => {
  const { t } = useTranslation("dialogs");
  const username = useSelector(getUsername);

  return (
    <>
      <span>
        {t("connectionProblem.user")} {username} {t("connectionProblem.notSetUp")}
      </span>
    </>
  );
};
